import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { settingsService, type PublicSettings } from '../services/settings.service';
import { Loader2, Shield } from 'lucide-react';

export default function Privacy() {
  const [settings, setSettings] = useState<PublicSettings>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await settingsService.getPublicSettings();
        setSettings(data || {});
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <section className="py-16 bg-white border-b">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <div className="inline-flex items-center justify-center bg-brand-50 text-brand-800 rounded-full w-14 h-14 mb-4">
                <Shield className="w-7 h-7" />
              </div>
              <h1 className="text-gray-900 mb-3">Política de Privacidade</h1>
              <p className="text-gray-600">Saiba como tratamos seus dados</p>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto bg-white border rounded-lg p-6 md:p-8">
              {loading ? (
                <div className="text-center py-12">
                  <Loader2 className="size-8 animate-spin text-brand-600 mx-auto mb-3" />
                  <p className="text-gray-600">Carregando conteúdo...</p>
                </div>
              ) : settings.privacy_content ? (
                <div className="prose max-w-none whitespace-pre-wrap leading-relaxed text-gray-800">
                  {settings.privacy_content.replace(/^\s*pol[ií]tica\s*(de\s*)?privacidade\s*/i, '')}
                </div>
              ) : (
                <div className="text-center py-12 text-gray-600">
                  <p>A Política de Privacidade ainda não foi publicada.</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

